module.exports = __webpack_public_path__ + "img/try.9bccf447.png";